import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { RateInfoType } from 'types/EmployeeRatesTypes'
import { MetaType } from "types/UtilsTypes";

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export default function useGetUserRates(role: string, page: number = 1) {
  return useQuery({
    queryKey: ["userRates", role, page],
    queryFn: async () => {
      await delay(1000); 
      return axiosInstance
        .get(`/users/rates`, { params: { role, page } })
        .then((res) => res.data);
    },
    select: (data: { users: {data: RateInfoType[], meta: MetaType } }) => data?.users,
    retry: false,
    staleTime: 0, 
  });
}
